export default "__VITE_ASSET__y0USaP$S__"